<template>
  <div>
    <div
      v-for="number in countItem"
      :key="`formio-item-${number}`"
      class="setting-formio">
      <sButton
        class="setting-formio__delete"
        icon="cross"
        small
        type="text"
        @click="deleteValue(number)"/>
      <SpilkaFormioMFOld
        ref="formioForm"
        :form="form"
        :hide-submit="true"
        @change="changeFormValue(number, $event.data)"
        @formLoad="setFormValue(number)"/>
    </div>
    <sButton
      v-if="multi"
      class="mt-2"
      :loading="!form"
      small
      type="border"
      @click="changeFormValue(countItem+1, defaultValue[0])">
      {{ $t('Common.Add') }}
    </sButton>
  </div>
</template>
<script>
import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'

export default {
  name: 'settingFormio',
  methods: {
    deleteValue(index) {
      let newValue = this.$_.cloneDeep(this.settingValue)
      newValue.splice(index - 1, 1)
      this.settingValue = newValue
    },
    changeFormValue(index, props) {
      const toCamelCase = (string) => {
        return string.charAt(0).toLowerCase() + string.slice(1)
      }
      const result = {}
      Object.entries(props).forEach((dataItem) => {
        result[toCamelCase(dataItem[0])] = dataItem[1]
      })
      let newValue = this.$_.cloneDeep(this.settingValue)
      if (this.multi) {
        if (newValue[index - 1]) {
          newValue[index - 1] = result
        } else {
          newValue.push(result)
        }
      } else {
        newValue = result
      }
      this.settingValue = newValue
    },
    setFormValue(index) {
      if (!this.$refs.formioForm[index - 1]) {
        this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: this.$t('OrgSettings.NotFindForm'),
          showClose: true,
          progress: true,
        })
        return
      }
      let settingValue = {}
      if (this.settingValue) {
        settingValue = this.multi ? this.settingValue[index - 1] : this.settingValue
      }

      const toPascalCase = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
      Object.entries(settingValue).forEach(settingValueItem => {
        this.$refs.formioForm[index - 1].setValueToItem(toPascalCase(settingValueItem[0]), settingValueItem[1])
      })
    },
  },
  computed: {
    countItem() {
      return this.multi ? this.settingValue?.length : 1
    },
    defaultValue() {
      return this.multi ? [{}] : {}
    },
    settingValue: {
      get: function () {
        if (!this.value) {
          return this.defaultValue
        }
        let valueParse = JSON.parse(this.value)
        let result
        if (this.multi && Array.isArray(valueParse)) {
          result = valueParse
        } else if (this.multi && !Array.isArray(valueParse)) {
          result = [valueParse]
        } else  if (!this.multi && Array.isArray(valueParse)) {
          result = valueParse[0]
        } else {
          result = valueParse
        }

        return result
      },
      set: function (newValue) {
        let result = this.multi ? this.defaultValue : [this.defaultValue]
        if (newValue) {
          if (this.multi && Array.isArray(newValue)) {
            result = newValue
          } else if (this.multi && !Array.isArray(newValue)) {
            result = [newValue]
          } else if (!this.multi && Array.isArray(newValue)) {
            result = newValue
          } else {
            result = [newValue]
          }
        }
        if (JSON.stringify(newValue) === JSON.stringify(this.value)) {
          return
        }
        this.$emit('update:value', result)
      }
    }
  },
  components: {
    SpilkaFormioMFOld
  },
  props: {
    form: {
      type: Object
    },
    multi: {
      type: Boolean,
      default: true
    },
    value: {
      type: String
    }
  },
}
</script>
<style scoped lang="scss">
.setting-formio {
  border: 2px solid var(--v-secondary__green_chosen-base);
  padding: 5px;
  position: relative;
  &__delete {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
}
</style>
